import type { FindOrdersRequestFilter } from '~domains/orders/entities/order';

import type { Pos } from '~entities/pos';

import { isOrderStatus } from './order-status';

import type { OrdersFiltersValue } from '../model/orders-filters';
import { getDefaultOrdersDateRange } from '../model/orders-filters';

export function buildOrdersFilter(
  filters: OrdersFiltersValue,
  onlinePosList: Pos[]
): FindOrdersRequestFilter {
  const onlineMerchantIds = [
    ...new Set(onlinePosList.map((pos) => pos.merchantId)),
  ];

  const merchantIds = filters.merchantIds.length
    ? filters.merchantIds
    : onlineMerchantIds;
  const merchantIdSet = new Set(merchantIds);

  const scopedPos = onlinePosList.filter((pos) =>
    merchantIdSet.has(pos.merchantId)
  );
  const scopedPosIds = new Set(scopedPos.map((pos) => pos.id));

  const posIds = filters.posIds.length
    ? filters.posIds.filter((id) => scopedPosIds.has(id))
    : [...scopedPosIds];

  const orderStatuses = filters.statuses.filter(isOrderStatus);

  const { startDate, endDate } = filters.period;
  const period =
    startDate && endDate ? { startDate, endDate } : getDefaultOrdersDateRange();

  return {
    dateFrom: period.startDate,
    dateTo: period.endDate,
    ...(merchantIds.length ? { merchantIds } : {}),
    ...(posIds.length ? { pointOfSaleIds: posIds } : {}),
    ...(orderStatuses.length ? { orderStatuses } : {}),
  };
}
